<template>
	<div>
	<el-dialog v-model="localVisible" title="申请售后" class="after-sales-dialog" width="75%" :close-on-click-modal="false" @opened="handleDialogOpened">
		<div class="order-section">
			
			<div class="purchase-list" style="flex: 1; overflow: hidden;">
				<div style="height: 100%;">
					<el-table ref="tableRef" :data="order.product" :header-cell-style="{ 'background-color': '#e5e5e5' }" size="small"
						style="width: 100%;" :height="tableHeight">
						<el-table-column prop="img" label="实图" width="70" header-align="center"
							show-overflow-tooltip>
							<template #default="scope">
								<div v-if="!scope.row.img || scope.row.img.length <= 0">
									<div @click="preview(scope.row, scope.row.img)">
										<el-image :src="require('@/assets/img/error_img.png')"
											loading="lazy" />
									</div>
								</div>
								<div v-else>
									<div @click="preview(scope.row, scope.row.img)">
										<el-image :src="scope.row.img[0]" loading="lazy" />
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="stock_type_txt" label="货物状态" header-align="center"
							width="200" show-overflow-tooltip>
							<template #default="scope">
								<div class="stock_type_txt_button">
									<span v-for="(item, idx) in scope.row.stock_type_txt_list"
										:key="idx">
											<el-button class="A" size="small" text bg
												v-if="item == '二手' || item == '过保' || item == '包附破损'"
												style="">{{ item }}</el-button>
											<el-button class="C" size="small" text bg v-else
												color="#ff8a5c">{{ item }}</el-button>
										</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
							<template #default="scope">
								<div class="product-info">
									<div class="brand-name" v-if="scope.row.product_brand_name">
										{{ scope.row.product_brand_name }}
									</div>
									<div class="product-name" v-if="scope.row.product_name">
										{{ scope.row.product_name }}
									</div>
									<div class="product-details" v-if="scope.row.product_model">
										<span class="detail-label">型号</span><span
											class="label-colon">：</span>
										<span class="detail-value">{{ scope.row.product_model
										}}</span>
									</div>
									<div class="product-details" v-if="scope.row.product_order_no">
										<span class="detail-label">订货号</span><span
											class="label-colon">：</span>
										<span class="detail-value">{{ scope.row.product_order_no
										}}</span>
									</div>
									<div class="product-details">
										<span class="detail-label">单位</span><span
											class="label-colon">：</span>
										<span class="detail-value">{{ scope.row.product_unit
										}}</span>
									</div>

									<span
										v-if="!scope.row.product_brand_name && !scope.row.product_name && !scope.row.product_model && !scope.row.product_order_no">
										-
									</span>

								</div>
							</template>
						</el-table-column>
						<el-table-column prop="tsw_price" align="center" header-align="center"
							label="单价" width="120" show-overflow-tooltip>
							<template #default="scope">
								<span class="price-value">{{ scope.row.price }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="num" label="数量" width="100" align="center"
							header-align="center">
							<template #default="scope">
								<span>{{ scope.row.num }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="tsw_money" align="center" header-align="center"
							label="金额" width="120" show-overflow-tooltip>
							<template #default="scope">
								<span class="price-value">{{ scope.row.sum }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" header-align="center" width="230">
							<template #header>
								<div class="after-sales-header">
									<div class="header-label">售后问题</div>
									<div class="header-value">售后数量</div>
								</div>
							</template>
							<template #default="scope">
							<div class="after-sales-inputs">
								<div class="after-sales-row">
									<el-input v-model="scope.row.afterSalesCounts.mismatch"
										 placeholder="请输入数量"
										:disabled="!showApplyButton"
										@input="handleAfterSalesInput(scope.row, 'mismatch')">
										<template #prepend><span class="prepend-label">与实物不符</span></template>
									</el-input>
								</div>
								<div class="after-sales-row">
									<el-input v-model="scope.row.afterSalesCounts.damaged"
										 placeholder="请输入数量"
										:disabled="!showApplyButton"
										@input="handleAfterSalesInput(scope.row, 'damaged')">
										<template #prepend><span class="prepend-label">坏货</span></template>
									</el-input>
								</div>
								<div class="after-sales-row">
									<el-input v-model="scope.row.afterSalesCounts.notReceived"
										 placeholder="请输入数量"
										:disabled="!showApplyButton"
										@input="handleAfterSalesInput(scope.row, 'notReceived')">
										<template #prepend><span class="prepend-label">未收到货</span></template>
									</el-input>
								</div>
								<el-select v-model="scope.row.afterSalesType" placeholder="售后方式"
									style="max-width: 260px; margin-top: 4px;" :disabled="!showApplyButton" clearable>
									<el-option label="退货退款" :value="1" />
									<el-option label="仅退款" :value="2" />
								</el-select>
							</div>
						</template>
						</el-table-column>
						<!-- 售后金额列 -->
							<el-table-column align="center" header-align="center" label="售后金额" width="200">
								<template #default="scope">
									<div class="after-sales-amounts">
										<div class="amount-item">
											<span class="amount-value">¥{{ getAfterSalesMoney(scope.row, 'mismatch') }}</span>
										</div>
										<div class="amount-item">
											<span class="amount-value">¥{{ getAfterSalesMoney(scope.row, 'damaged') }}</span>
										</div>
										<div class="amount-item">
											<span class="amount-value">¥{{ getAfterSalesMoney(scope.row, 'notReceived') }}</span>
										</div>
										<div class="amount-item">
											<span class="amount-value"> </span>
										</div>
									</div>
								</template>
							</el-table-column>
						<!-- 上传图片列 -->
						<el-table-column align="center" header-align="center" label="上传图片" width="150">
							<template #default="scope">
								<el-upload
								list-type="picture-card"
								:file-list="scope.row.afterSalesImages || []"
								:on-preview="(file) => handlePreview(file, scope.row)"
								:on-remove="(file, fileList) => handleRemove(file, fileList, scope.row)"
								:before-upload="(file) => beforeUpload(file, scope.row)"
								:on-change="(file, fileList) => handleChange(file, fileList, scope.row)"
								:auto-upload="false"
								:limit="5"
								:disabled="!showApplyButton"
							>
									<template #file="{ file }">
										<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" @click.stop="handlePreview(file, scope.row)">
										<span class="el-upload-list__item-actions" v-if="showApplyButton">
											<span
												class="el-upload-list__item-delete"
												@click="handleRemove(file, scope.row.afterSalesImages.filter(img => img.url !== file.url && img.name !== file.name), scope.row)"
											>
												<el-icon><Delete /></el-icon>
											</span>
										</span>
									</template>
									<el-icon><Plus /></el-icon>
								</el-upload>
							</template>
						</el-table-column>
					</el-table>
					<!-- 售后说明 -->
					<div class="after-sales-remark-container">
						<el-input
							v-model="afterSalesRemark"
							type="textarea"
							:rows="3"
							placeholder="请输入售后说明"
							:disabled="!showApplyButton"
						/>
					</div>
				 
			</div>
			</div>
		</div>

		<!-- 底部栏 -->
		<div class="after-sales-footer">
			<div class="footer-left">
				<div class="total-info">
					<span class="total-label">商品数量：</span>
					<span class="total-value">{{ order.total_num || 0 }} 件</span>
				</div>
				<div class="total-info">
					<span class="total-label">售后数量：</span>
					<span class="total-value">{{ totalAfterSalesNum }} 件</span>
				</div>
				<div class="total-info">
					<span class="total-label">售后金额：</span>
					<span class="total-amount">¥{{ totalAfterSalesMoney }}</span>
				</div>
				<div class="total-info">
					<span class="total-label">减免金额：</span>
					<span class="total-amount">¥{{ order.goods_discount }}</span>
				</div>
				<div class="total-info">
					<span class="total-label">快递费用：</span>
					<span class="total-amount">¥{{ order.freight_fee }}</span>
				</div>
				<div class="total-info" v-if="order.state === 1">
					<span class="total-label">退款金额：</span>
					<span class="total-amount">¥{{ order.refund_money }}</span>
				</div>
				<div class="total-info" >
					<span class="total-label">实际支付金额：</span>
					<span class="total-amount">¥{{ order.total_order_money }}</span>
				</div>
			</div>
			<div class="footer-right">
				<el-button v-if="showApplyButton" type="primary" size="small" @click="handleApply">申请售后</el-button>
				<template v-else>
					<span  
						class="status-text"
						:class="{
							'status-pending': order.state === 0,
							'status-completed': order.state === 1,
							'status-rejected': order.state === 2
						}"
					>
						{{ order.state === 0 ? '处理中' : order.state === 1 ? '已处理' : '已拒绝' }}
					</span>
					<div v-if="order.state === 2 && order.reject_reason" class="reject-reason-wrapper">
						<span class="reject-reason-label">拒绝原因：</span>
						<span class="reject-reason-text">{{ order.reject_reason }}</span>
					</div>
				</template>
			</div>
		</div>
	</el-dialog>

	<!-- 图片预览放大组件 -->
	<el-image-viewer
		v-if="showImageViewer"
		:url-list="srcList"
		:initial-index="previewStartIndex"
		@close="showImageViewer = false"
	/>
	</div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted, getCurrentInstance, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus, Delete } from '@element-plus/icons-vue';

const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	},
	order: {
		type: Object,
		default: () => ({})
	},
	showApplyButton: {
		type: Boolean,
		default: true
	},
	aftersale_id: {
		type: [Number, String],
		default: null
	},
	reject_reason: {
		type: String,
		default: ''
	}
});

const emit = defineEmits(['update:visible', 'apply']);

const srcList = ref([]);
const localVisible = ref(props.visible);
const tableRef = ref(null);
const tableHeight = ref(700);
const afterSalesRemark = ref('');
// 图片预览相关
const showImageViewer = ref(false);
const previewStartIndex = ref(0);

// 获取Vue实例，用于访问$bn
const { proxy } = getCurrentInstance();

// 初始化售后数量和图片
const initAfterSalesCounts = () => {
	if (props.order.product && props.order.product.length > 0) {
		afterSalesRemark.value = props.order.remark || '';
		props.order.product.forEach(function (row) {
			if (!row.afterSalesCounts) {
				row.afterSalesCounts = {
					mismatch: 0,
					damaged: 0,
					notReceived: 0
				};
			}
			if (!row.afterSalesImages) {
				row.afterSalesImages = [];
			}
			if (!row.afterSalesType) {
				row.afterSalesType = '';
			}
		});
	}
};

// 计算表格高度
const calculateTableHeight = () => {
	nextTick(() => {
		const screenHeight = window.innerHeight;
		const dialogHeaderHeight = 60;
		const orderSectionPadding = 32;
		const footerHeight = 80;
		const margin = 60;
		const remarkHeight = 80; // 售后说明输入框高度
		const minTableHeight = 200;
		const calculatedHeight = screenHeight - dialogHeaderHeight - orderSectionPadding - footerHeight - margin - 70 - remarkHeight;
		tableHeight.value = Math.max(calculatedHeight, minTableHeight);
	});
};

// 弹窗打开后处理
const handleDialogOpened = async () => {
	if (props.aftersale_id) {
		await getAfterSaleDetail();
	}
	initAfterSalesCounts();
	// 延迟一点时间确保DOM完全渲染
	calculateTableHeight();
};

// 获取售后详情
const getAfterSaleDetail = async () => {
	try {
		const res = await proxy.$axios.post('/api/yunsys.Order/getaftersaledetail', {
			aftersale_id: props.aftersale_id
		});
		const data = res.data;
		if (data.code === 0) {
			// 将获取到的详情数据赋值给 order
				data.data.forEach(item => {
					item.stock_type_txt_list = item.stock_type_txt ? item.stock_type_txt.split("、") : [];
					// 处理售后数量数据
			item.afterSalesCounts = {
				mismatch: item.mismatch || '',
				damaged: item.damaged || '',
				notReceived: item.notReceived || ''
			};
			// 处理售后方式数据
			item.afterSalesType = item.after_sales_type || '';
					// 处理售后图片数据
					if (item.afterimgs && item.afterimgs.length > 0) {
						item.afterSalesImages = item.afterimgs.map((imgUrl, index) => ({
							name: `售后图片${index + 1}`,
							url: proxy.$axios.defaults.baseURL + imgUrl
						}));
						console.log(item.afterSalesImages);
					} else {
						item.afterSalesImages = [];
					}
				});
			Object.assign(props.order, { 
				product: data.data || []
			});
		} else {
			ElMessage.error(data.msg || '获取售后详情失败');
		}
	} catch (err) {
		console.error('获取售后详情失败:', err);
		ElMessage.error('系统错误');
	}
};

onMounted(() => {
	initAfterSalesCounts();
	window.addEventListener('resize', calculateTableHeight);
});

onUnmounted(() => {
	window.removeEventListener('resize', calculateTableHeight);
});

// 监听visible变化，同步到本地状态
watch(() => props.visible, (newVal) => {
	localVisible.value = newVal;
});

// 监听order变化，立即初始化售后数量
watch(() => props.order, () => {
	initAfterSalesCounts();
}, { immediate: true, deep: true });

watch(localVisible, (newVal) => {
	emit('update:visible', newVal);
});

// 获取指定类型的售后金额
const getAfterSalesMoney = (row, type) => {
	if (!row.afterSalesCounts) {
		return '0.00';
	}
	const count = parseInt(row.afterSalesCounts[type]) || 0;
	const price = parseFloat(row.price) || 0;
	if (count > 0 && price > 0) {
		return proxy.$bn.multiply(price, count, 2);
	}
	return '0.00';
};

// 获取当前行的总售后金额
const getRowTotalAfterSalesMoney = (row) => {
	if (!row.afterSalesCounts) {
		return '0.00';
	}
	const mismatch = parseInt(row.afterSalesCounts.mismatch) || 0;
	const damaged = parseInt(row.afterSalesCounts.damaged) || 0;
	const notReceived = parseInt(row.afterSalesCounts.notReceived) || 0;
	const total = mismatch + damaged + notReceived;
	const price = parseFloat(row.price) || 0;
	if (total > 0 && price > 0) {
		return proxy.$bn.multiply(price, total, 2);
	}
	return '0.00';
};

// 处理售后数量输入
const handleAfterSalesInput = (row, field) => {
	// 获取当前字段的新值（用户刚输入的）
	const newVal = row.afterSalesCounts[field];
	const newInputVal = parseInt(newVal) || 0;
	const maxNum = parseInt(row.num) || 0;
	
	// 计算三个字段的总和
	const mismatch = field === 'mismatch' ? newInputVal : (parseInt(row.afterSalesCounts.mismatch) || 0);
	const damaged = field === 'damaged' ? newInputVal : (parseInt(row.afterSalesCounts.damaged) || 0);
	const notReceived = field === 'notReceived' ? newInputVal : (parseInt(row.afterSalesCounts.notReceived) || 0);
	const total = mismatch + damaged + notReceived;
	
	// 校验数量，如果超出则拒绝输入
	if (total > maxNum) {
		// 计算其他两个字段的和
		let otherTotal = 0;
		if (field !== 'mismatch') {
			otherTotal += parseInt(row.afterSalesCounts.mismatch) || 0;
		}
		if (field !== 'damaged') {
			otherTotal += parseInt(row.afterSalesCounts.damaged) || 0;
		}
		if (field !== 'notReceived') {
			otherTotal += parseInt(row.afterSalesCounts.notReceived) || 0;
		}
		
		// 恢复到输入前的值（这里需要计算出输入前的值）
		const oldVal = maxNum - otherTotal;
		row.afterSalesCounts[field] = oldVal > 0 ? oldVal : '';
		return ElMessage({
					message: '售后数量总和不能超过商品总数量',
					type: 'error',
					grouping: true // 开启合并功能
				})
	}
	
	// 使用bn.multiply格式化数值
	if (row.afterSalesCounts.mismatch !== '') {
		row.afterSalesCounts.mismatch = proxy.$bn.multiply(row.afterSalesCounts.mismatch, 1, 0);
	}
	if (row.afterSalesCounts.damaged !== '') {
		row.afterSalesCounts.damaged = proxy.$bn.multiply(row.afterSalesCounts.damaged, 1, 0);
	}
	if (row.afterSalesCounts.notReceived !== '') {
		row.afterSalesCounts.notReceived = proxy.$bn.multiply(row.afterSalesCounts.notReceived, 1, 0);
	}
};

// 计算总售后数量
const totalAfterSalesNum = computed(() => {
	let total = 0;
	if (props.order.product && props.order.product.length > 0) {
		props.order.product.forEach(function (row) {
			if (row.afterSalesCounts) {
				const mismatch = parseInt(row.afterSalesCounts.mismatch) || 0;
				const damaged = parseInt(row.afterSalesCounts.damaged) || 0;
				const notReceived = parseInt(row.afterSalesCounts.notReceived) || 0;
				total += mismatch + damaged + notReceived;
			}
		});
	}
	return total;
});

// 计算与实物不符总金额
const totalMismatchMoney = computed(() => {
	let total = 0;
	if (props.order.product && props.order.product.length > 0) {
		props.order.product.forEach(function (row) {
			if (row.afterSalesCounts) {
				const count = parseInt(row.afterSalesCounts.mismatch) || 0;
				const price = parseFloat(row.price) || 0;
				if (count > 0 && price > 0) {
					total = proxy.$bn.add(total, proxy.$bn.multiply(price, count, 2), 2);
				}
			}
		});
	}
	return total;
});

// 计算坏货总金额
const totalDamagedMoney = computed(() => {
	let total = 0;
	if (props.order.product && props.order.product.length > 0) {
		props.order.product.forEach(function (row) {
			if (row.afterSalesCounts) {
				const count = parseInt(row.afterSalesCounts.damaged) || 0;
				const price = parseFloat(row.price) || 0;
				if (count > 0 && price > 0) {
					total = proxy.$bn.add(total, proxy.$bn.multiply(price, count, 2), 2);
				}
			}
		});
	}
	return total;
});

// 计算未收到货总金额
const totalNotReceivedMoney = computed(() => {
	let total = 0;
	if (props.order.product && props.order.product.length > 0) {
		props.order.product.forEach(function (row) {
			if (row.afterSalesCounts) {
				const count = parseInt(row.afterSalesCounts.notReceived) || 0;
				const price = parseFloat(row.price) || 0;
				if (count > 0 && price > 0) {
					total = proxy.$bn.add(total, proxy.$bn.multiply(price, count, 2), 2);
				}
			}
		});
	}
	return total;
});

// 计算总售后金额
const totalAfterSalesMoney = computed(() => {
	let total = 0;
    var obj=this
	if (props.order.product && props.order.product.length > 0) {
		props.order.product.forEach(function (row) {
			if (row.afterSalesCounts) {
				const mismatch = parseInt(row.afterSalesCounts.mismatch) || 0;
				const damaged = parseInt(row.afterSalesCounts.damaged) || 0;
				const notReceived = parseInt(row.afterSalesCounts.notReceived) || 0;
				const rowTotal = mismatch + damaged + notReceived;
					const price = parseFloat(row.price) || 0;
					if (rowTotal > 0 && price > 0) {
						total = proxy.$bn.add(total, proxy.$bn.multiply(price, rowTotal, 2), 2);
					}
			}
		});
	}
	return total;
});

const preview = (row, img) => {
	srcList.value = [];
	if (img) {
		img.forEach(function (item) {
			srcList.value.push(item)
		})
	}
};

// 上传图片前处理
const beforeUpload = (file, row) => {
	const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
	if (!isJPG) {
		ElMessage.error('上传图片只能是 JPG 或 PNG 格式!');
		return false;
	}
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isLt2M) {
		ElMessage.error('上传图片大小不能超过 2MB!');
		return false;
	}
	return true;
};

// 图片变化处理
const handleChange = (file, fileList, row) => {
	if (file.status === 'ready') {
		const reader = new FileReader();
		reader.readAsDataURL(file.raw);
		reader.onload = () => {
			const base64 = reader.result;
			row.afterSalesImages.push({
				name: file.name,
				url: base64
			});
		};
	}
};

// 图片删除处理
const handleRemove = (file, fileList, row) => {
	row.afterSalesImages = fileList.map(item => ({
		name: item.name,
		url: item.url
	}));
};

// 图片预览
const handlePreview = (file, row) => {
	srcList.value = row.afterSalesImages.map(item => item.url);
	// 找到当前点击的图片索引
	const index = row.afterSalesImages.findIndex(item => item.url === file.url);
	previewStartIndex.value = index >= 0 ? index : 0;
	showImageViewer.value = true;
};

const handleApply = async () => {
	// 校验售后数量
	let total = 0;
	let maxTotal = 0;
	let hasInvalidProduct = false;
	let hasProductWithQuantityButNoType = false;
	if (props.order.product && props.order.product.length > 0) {
		props.order.product.forEach(function (row) {
			let rowTotal = 0;
			if (row.afterSalesCounts) {
				const mismatch = parseInt(row.afterSalesCounts.mismatch) || 0;
				const damaged = parseInt(row.afterSalesCounts.damaged) || 0;
				const notReceived = parseInt(row.afterSalesCounts.notReceived) || 0;
				rowTotal = mismatch + damaged + notReceived;
				total += rowTotal;
			}
			
			// 双向验证
			if (rowTotal > 0 && !row.afterSalesType) {
				// 有售后数量但没有选择售后方式
				hasProductWithQuantityButNoType = true;
			} else if (row.afterSalesType && rowTotal === 0) {
				// 选择了售后方式但没有售后数量
				hasInvalidProduct = true;
			}
			
			maxTotal += parseInt(row.num) || 0;
		});
	}

	if (hasProductWithQuantityButNoType) {
		ElMessage.warning('有售后数量的商品必须选择售后方式');
		return;
	}

	if (hasInvalidProduct) {
		ElMessage.warning('选择了售后方式的商品必须填写售后数量');
		return;
	}

	if (total === 0) {
		ElMessage.warning('请填写售后数量');
		return;
	}

	if (total > maxTotal) {
		ElMessage.warning('售后数量总和不能超过商品总数量');
		return;
	}

	try {
		// 调用后端接口申请售后
		const res = await proxy.$axios.post('/api/yunsys.Order/addaftersale', {
			pay_no: props.order.pay_no,
			remark: afterSalesRemark.value,
			afterSalesData: props.order.product.map(function (row) {
				return {
					product_id: row.id,
					mismatch: row.afterSalesCounts ? row.afterSalesCounts.mismatch : '',
					damaged: row.afterSalesCounts ? row.afterSalesCounts.damaged : '',
					notReceived: row.afterSalesCounts ? row.afterSalesCounts.notReceived : '',
					after_sales_type: row.afterSalesType || '',
					images: row.afterSalesImages ? row.afterSalesImages.map(item => item.url) : []
				};
			})
		});

		const data = res.data;
		console.log('后端返回数据:', data);
		if (data.code === 0 || data.code === '0') {
			ElMessage.success('申请售后成功');
			// 直接通知父组件关闭
			emit('update:visible', false);
			emit('apply');
		} else {
			ElMessage.error(data.msg || '申请售后失败');
		}
	} catch (err) {
		console.error('申请售后失败:', err);
		ElMessage.error('系统错误');
	}
};
</script>

<style scoped>
.after-sales-dialog {
	display: flex;
	flex-direction: column;
	height: 90vh !important;
}

.after-sales-dialog .el-dialog__body {
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	padding: 20px;
}

.after-sales-dialog .el-dialog__header {
	flex-shrink: 0;
}
.order-section {
	background: #fff;
	border-radius: 12px;
	margin-bottom: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #333;
	margin-bottom: 16px;
	padding-bottom: 12px;
	display: flex;
	align-items: center;

	&::before {
		content: '';
		display: inline-block;
		width: 4px;
		height: 16px;
		background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
		border-radius: 2px;
		margin-right: 10px;
	}
}
:deep( .el-table .el-input__wrapper,.el-table .el-select__wrapper){
        box-shadow: 0 0 0 1px var(--el-input-border-color,var(--el-border-color)) inset !important;
    }
	:deep( .el-table .el-select__wrapper){
        box-shadow: 0 0 0 1px var(--el-input-border-color,var(--el-border-color)) inset !important;
    }
.product-info {
   
	.brand-name {
		font-weight: 600;
		color: #333;
		font-size: 14px;
	}

	.product-name {
		color: #666;
		font-size: 14px;
		margin-top: 4px;
	}

	.product-details {
		font-size: 13px;
		margin-top: 4px;

		.detail-label {
			color: #999;
		}

		.label-colon {
			color: #999;
		}

		.detail-value {
			color: #666;
		}
	}
}

.price-value {
	color: #ff8a5c;
	font-weight: 600;
}

.after-sales-header {
	display: flex;
	justify-content: space-between;
	padding: 0 10px;
}

.header-label {
	font-weight: 600;
	color: #333;
}

.header-value {
	font-weight: 600;
	color: #333;
	margin-left: 30px;
}

.after-sales-inputs {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.after-sales-row {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 4px;
	width: 100%;
	height: 32px;
}

.after-sales-row:last-of-type {
	margin-bottom: 0;
}

.after-sales-amount {
	color: #ff8a5c;
	font-weight: 600;
	font-size: 14px;
	white-space: nowrap;
}

.after-sales-amounts {
	display: flex;
	flex-direction: column;
	gap: 4px;
	text-align: center;
}

.amount-item {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 2.2rem;
}

.amount-label {
	color: #666;
	font-size: 13px;
}

.amount-value {
	color: #ff8a5c;
	font-weight: 600;
	font-size: 14px;
}

.prepend-label {
	display: inline-block;
	width: 80px;
    text-align: justify;
  -moz-text-align-last: justify;
  text-align-last: justify;
  text-justify: inter-character;
}

.stock_type_txt_button {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
}

.after-sales-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 16px;
	border-top: 1px solid #e8e8e8;
}

.footer-left {
	display: flex;
	gap: 24px;
	align-items: center;
}

.total-info {
	font-size: 14px;
}

.total-label {
	color: #666;
	margin-right: 8px;
}

.total-value {
	color: #333;
}

.total-amount {
	color: #ff8a5c;
	font-weight: 700;
	font-size: 18px;
}
.after-sales-remark-container{
	margin: 5px;
}

.after-sales-remark-container :deep(.el-textarea__inner:focus) {
	border-color: #ff8a5c;
	box-shadow: 0 0 0 2px rgba(255, 138, 92, 0.2);
}
.footer-right {
			display: flex;
			gap: 12px;
		}

.status-text {
	padding: 4px 12px;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 500;
	display: inline-flex;
	align-items: center;
	line-height: 1.5;
}

.status-pending {
	background-color: #fdf6ec;
	color: #e6a23c;
}

.status-completed {
	background-color: #f0f9ff;
	color: #67c23a;
}

.status-rejected {
	background-color: #fef0f0;
	color: #f56c6c;
}

.reject-reason-wrapper {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	background: #fff1f0;
	border: 1px solid #fbc4c4;
	border-radius: 4px;
}

.reject-reason-label {
	color: #f56c6c;
	font-weight: 500;
	font-size: 13px;
	white-space: nowrap;
}

.reject-reason-text {
	color: #333;
	font-size: 13px;
}

	:deep(.el-upload--picture-card) {
		width: 40px !important;
		height: 40px !important;
        border-radius: 0rem;
	}
    :deep(.el-upload-list__item.is-success .el-upload-list__item-status-label) {
  display: none;
}
	:deep(.el-upload-list--picture-card .el-upload-list__item) {
		width: 40px !important;
		height: 40px !important;
	}

	:deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
		width: 40px !important;
		height: 40px !important;
		object-fit: cover;
	}

	:deep(.el-upload-list__item-preview) {
		display: none !important;
	}

	:deep(.el-upload-list__item-actions) {
		position: absolute;
		top: 0;
		width: max-content !important;
		height: max-content !important;
		opacity: 1 !important;
		background: none !important;
        right: 0 !important;
        left: auto !important;
	}

	:deep(.el-upload-list__item:hover .el-upload-list__item-actions) {
		opacity: 1 !important;
	}

	:deep(.el-upload-list__item-delete) {
		background: transparent !important;
		padding: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
        display:block !important
	}

	:deep(.el-upload-list__item-delete .el-icon) {
		color: #f56c6c;
		font-size: 16px;
        
	}
</style>

<style>

@media (max-width: 1300px) {
	 .after-sales-dialog {
		width: 98% !important;
	}
}
</style>